export const FEATURED_LIVESHOPPING = '/api/live-shopping/featured';
export const LIVE_SHOPPING_QUERY = '/api/live-shopping';

export const RELATED_VEHICLES_QUERY = '/api/search';
